import React from 'react';
import { GraduationCap, Trophy, Award, Medal, Users, Code } from 'lucide-react';
import { educationData, achievementsData } from '../data/mockData';

const Education = () => {
  const getAchievementIcon = (iconName) => {
    switch (iconName) {
      case 'trophy':
        return Trophy;
      case 'medal':
        return Medal;
      case 'users':
        return Users;
      case 'code':
        return Code;
      case 'award':
        return Award;
      default:
        return Award;
    }
  };

  return (
    <section id="education" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Education */}
          <div>
            <div className="mb-12">
              <span className="text-emerald-600 font-medium text-sm tracking-wide uppercase">
                Education
              </span>
              <h2 className="text-3xl font-light text-gray-900 mt-2">
                Academic{' '}
                <span className="font-semibold">Background</span>
              </h2>
            </div>

            <div className="space-y-6">
              {educationData.map((edu) => (
                <div
                  key={edu.id}
                  className="relative pl-8 pb-6 border-l-2 border-gray-200 last:border-l-0 last:pb-0"
                >
                  {/* Timeline Dot */}
                  <div className="absolute left-0 top-0 transform -translate-x-1/2 w-4 h-4 bg-emerald-500 rounded-full border-4 border-white shadow" />
                  
                  <div className="bg-gray-50 rounded-xl p-5 hover:shadow-md transition-shadow">
                    <div className="flex items-start justify-between">
                      <div>
                        <h3 className="font-semibold text-gray-900 mb-1">
                          {edu.degree}
                        </h3>
                        <p className="text-gray-600 text-sm mb-2">
                          {edu.institution}
                        </p>
                        <div className="flex items-center space-x-4 text-sm text-gray-500">
                          <span>{edu.board}</span>
                          <span>•</span>
                          <span>{edu.year}</span>
                        </div>
                      </div>
                      <div className="flex flex-col items-end">
                        <GraduationCap className="w-5 h-5 text-emerald-600 mb-2" />
                        <span className="text-lg font-bold text-emerald-600">
                          {edu.result}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Achievements */}
          <div>
            <div className="mb-12">
              <span className="text-emerald-600 font-medium text-sm tracking-wide uppercase">
                Recognition
              </span>
              <h2 className="text-3xl font-light text-gray-900 mt-2">
                Achievements &{' '}
                <span className="font-semibold">Awards</span>
              </h2>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              {achievementsData.map((achievement) => {
                const IconComponent = getAchievementIcon(achievement.icon);
                return (
                  <div
                    key={achievement.id}
                    className="group p-5 bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-100 hover:shadow-lg hover:border-emerald-200 transition-all duration-300"
                  >
                    <div className="flex items-start space-x-4">
                      <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-500 transition-colors">
                        <IconComponent className="w-5 h-5 text-emerald-600 group-hover:text-white transition-colors" />
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 text-sm mb-1">
                          {achievement.title}
                        </h4>
                        <p className="text-gray-500 text-xs leading-relaxed mb-2">
                          {achievement.description}
                        </p>
                        <span className="text-xs text-emerald-600 font-medium">
                          {achievement.date}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
